export default __webpack_public_path__ + "2dcfe6c81cd955994d0739260cc40a65.svg";